<!--
    我的课程-课程详情
    功能：展示课程包信息详情、课包上课/预览/获取离线包
    说明：版本3.0
-->
<template>
  <div
    v-loading="loading"
    class="wrapper">
    <el-scrollbar
      wrap-style="overflow-x:hidden;"
      style="flex:1">
      <div class="page-content">
        <detail-top :detail="topInfo"/>
        <detail-content
          :detail="contentInfo"
          :goods-list="goodsList"
          :is-cascader="isCascader"
          :get-cascader="getCascader"
          @search="handlerSearch"
          @setCheckItem="setCheckItem"/>
      </div>
    </el-scrollbar>
    <div
      class="bottom-btns">
      <el-button
        class="item"
        @click="handlerPreview()">预 览</el-button>
      <!-- <el-button
        v-if="user.is_course_make&&user.is_course_make === 1"

        class="item"
        @click="handlerClass()">上 课</el-button> -->
      <el-button
        class="item"
        @click="handlerClass()">上 课</el-button>
      <!--  <el-button
        class="item"
        type="primary"
        @click="handlerDown()">获取离线包</el-button> -->
    </div>
    <el-dialog
      :visible.sync="iframeData.show"
      :title="iframeData.title"
      :close-on-click-modal="false"
      :modal="false"
      width="692px"
    >
      <div style="height:389.25px">
        <iframe
          v-if="iframeData.show"
          id="iframe"
          :src="iframeData.src"
          frameborder="0"
          width="100%"
          style="display: block;"
          height="389.25px"
        />
      </div>
    </el-dialog>
    <package-status
      v-if="isPackageStatus"
      :visible.sync="isPackageStatus"
      :form.sync="packageItem"
      :rate.sync="packageRate"
      @success="successPackageStatus"
    />
  </div>
</template>
<script>
/* eslint-disable no-unused-expressions */
/* eslint-disable import/extensions */
/* eslint-disable import/first */
/* eslint-disable default-case */
import detailTop from './components/detailTop.vue';
import detailContent from './components/detailContent.vue';
import { fetchAuthCourseDetail } from '@/api/myCourse';
import { getCombinePack, getCombinePackStatus } from '@/api/api';
import packageStatus from '@/components/PackageStatus/index';

export default {
  name: 'PackageDetail',
  components: {
    detailTop,
    detailContent,
    packageStatus,
  },
  data() {
    return {
      loading: false,
      topInfo: {},
      contentInfo: {},
      goodsList: [],
      getCascader: [],
      isCascader: false,
      iframeData: {
        show: false,
        title: '',
        src: '',
      },
      checkItem: {},
      isPackageStatus: false, // 课包打包状态
      packageItem: null, // 包内容
      packageRate: 0, // 课件包打包进度
      runPackageFn: null, // 轮询打包状态
      isFromGoods: false, // 是否是从课程商品跳转过来
      code: '',
      user: this.$store.state.user,
      choicesSchool: this.$store.state.choicesSchool,
    };
  },
  mounted() {
    this.geDetail();
    this.$http.get(`api/staff?equal[uuid]=${this.$store.state.user.uuid}`).then((res) => {
      this.user = res.items[0];
    });
  },
  methods: {
    geDetail() {
      this.loading = true;
      fetchAuthCourseDetail(this.$route.query.packetAuthId, this.$store.state.choicesSchool.id).then((res) => {
        this.loading = false;
        const { auth_expire_time, auth_number, used_number } = res.data;
        const { cover, name, clients, created_at, detail_count, created_users } = res.data.packet;
        this.topInfo = {
          cover,
          name,
          company_name:clients.review_used["name"],
          created_at,
          detail_count,
          auth_expire_time,
          auth_number,
          created_users,
          used_number,
        };
        this.contentInfo = res.data.packet;
        this.getCascader = this.clearArrayEmpty(res.data.packet.detail_category_tree);
        const coursePackage = [];
        this.isCascader = res.data.packet.details.length > 0;
        res.data.packet.details.forEach((item) => {
          const obj = {
            detail_category_id: item.detail_category_id,
            sort: item.sort,
            ...item.result,
          };
          coursePackage.push(obj);
        });
        coursePackage.sort((a, b) => a.sort - b.sort);
        this.goodsList = coursePackage;
        sessionStorage.setItem('myHours', JSON.stringify(coursePackage));
        this.code = res.data.packet.code;
      });
    },
    // 查询
    handlerSearch(val) {
      const classHours = JSON.parse(sessionStorage.getItem('myHours'));
      const newArr = [];
      classHours.forEach((item) => {
        if (item.detail_category_id === val) {
          newArr.push(item);
        }
      });
      this.goodsList = !val ? classHours : newArr;
    },
    // 去掉空值
    clearArrayEmpty(data) {
      data && data.forEach((val) => {
        if (val.recursive_children) {
          if (val.recursive_children.length) {
            this.clearArrayEmpty(val.recursive_children);
          } else {
            // eslint-disable-next-line no-param-reassign
            val.recursive_children = undefined;
          }
        }
      });
      return data;
    },
    // 设置选中项
    setCheckItem(val) {
      this.checkItem = val;
    },
    // 预览
    handlerPreview() {
      if (this.checkItem.id) {
        this.iframeData.title = this.checkItem.name;
        const url = this.$domain.editor;
        this.iframeData.src = `${url}/preview?platform=vue&scene=preview&fullScreen=true&id=${this.checkItem.id}&version=${this.checkItem.attr_id_used}&school_id=${localStorage.getItem('school_id') || this.$store.state.choicesSchool.id}`;
        this.iframeData.show = true;
      } else {
        this.$message.warning('请选择课时！');
      }
    },
    // 上课
    handlerClass() {
      if (this.checkItem.id) {
        console.log(this.checkItem);
        // console.log(this.$route.query.packetAuthId);
        this.getSomeData();
        localStorage.setItem('my_class_data', this.someData);
        this.$router.push('/myClass/myCreate');
      } else {
        this.$message.warning('请选择课时！');
      }
    },
    // 课件 - 主要数据
    getSomeData() {
      const {
        id,
        name,
        title,
        attr_id_used,
      } = this.checkItem;

      this.someData = JSON.stringify({
        id,
        name,
        title,
        liveroom_course_type: 3, // 值为2或3跳转, 否则不要跳转, 提示 "暂不支持网页上课"(选课类型：1=AI课件；2=AI双师课；3=互动课件；4=其它；5=互动视频课)
        liveroom_new_course_type: 2, // （选填）直播绑定新课件类型：0=其他;1=校区课件;2=授权课件
        // commodities_orders_code: this.code, // （选填）课程商品订单编号
        hide_course_type: 'online_left', // 'offline_left': 隐藏线下课; 或 'online_left': 隐藏线上课
        attr_id_used, // 预览 - 互动课件
      });
      return this.someData;
    },
    // 下载
    async handlerDown() {
      if (this.checkItem.id) {
        this.packageRate = 0;
        const res = await getCombinePack({
          resultId: this.checkItem.id,
          clientsId: this.$store.state.choicesSchool.id,
        });
        if (res && res.status_code === 200) {
          // 1.课包已经是最新的，直接下载
          window.open(res.data);
        } else if (res && res.status_code === 407) {
          // 1.课包打包弹窗
          this.isPackageStatus = true;
          this.packageItem = this.checkItem;
          this.getPackageProgress(this.checkItem);
        } else {
          this.$message.warning(res && res.message);
        }
      } else {
        this.$message.warning('请选择课时！');
      }
    },
    // 获取课件包打包进度
    async getPackageProgress(item) {
      console.log('getPackageProgress==>', item);
      const func = async (callback) => {
        const res = await getCombinePackStatus(({
          resultId: item.id,
          clientsId: this.$store.state.choicesSchool.id,
        }));
        if (res && res.status_code === 200) {
          callback({
            ...res.data,
          });
        } else {
          callback(false);
        }
      };
      const callbackFunc = async (res) => {
        if (!res) {
          // 请求失败
        } else {
          const { status, progress, message } = res;
          switch (status) {
            case 'failure':
              // 获取失败
              this.$message.error(message);
              break;
            case 'success': {
              // 去下载
              const result = await getCombinePack({
                resultId: item.id,
                clientsId: this.$store.state.choicesSchool.id,
              });
              this.isPackageStatus = false;
              this.packageItem = null;
              window.open(result.data);
              break;
            }
            case 'run': {
              // 正在打包-有打包进度
              this.packageRate = progress;
              this.runPackageFn = setTimeout(() => {
                func(callbackFunc);
                clearTimeout(this.runPackageFn);
              }, 1000);
              break;
            }
          }
        }
      };
      func(callbackFunc);
    },
    // 打包成功后
    successPackageStatus() {
      clearTimeout(this.runPackageFn);
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper{
  padding: 24px 10px;
  height: 100vh!important;
  flex: none!important;
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  box-sizing: border-box;
  .page-content{
      padding: 0 20px;
  }
}
.bottom-btns{
   height: 60px;
   box-sizing: border-box;
   padding-top: 20px;
   text-align: center;
   border-top: 1px solid #f8f8f8;
   .item{
       margin: 0 10px;
   }
}
</style>



// WEBPACK FOOTER //
// src/views/MyCourse/packageDetail/index.vue